import React from "react";

const TopPartnersTable = ({ partners, onViewAll }) => {
	const formatCurrency = (amount) => {
		return new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		}).format(amount || 0);
	};

	const getVarianceIcon = (acceptable) => {
		return acceptable ? (
			<span style={{ color: "var(--success-color)", fontSize: "16px" }}>✓</span>
		) : (
			<span style={{ color: "var(--warning-color)", fontSize: "16px" }}>⚠</span>
		);
	};

	const getStatusColor = (overdueDays) => {
		if (overdueDays > 0) return "var(--danger-color)";
		return "var(--success-color)";
	};

	return (
		<div>
			<div style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				marginBottom: "var(--spacing-xl)"
			}}>
				<h3 style={{ margin: 0, fontSize: "20px", fontWeight: "700" }}>
					Top 5 Partners
				</h3>
				<button className="btn-secondary-v4" onClick={onViewAll}>
					View All Partners →
				</button>
			</div>

			<div className="table-container-v4">
				<table className="data-table-v4">
					<thead>
						<tr>
							<th>Partner</th>
							<th>Our Revenue</th>
							<th>Partner Reported</th>
							<th>User Payout</th>
							<th>Margin</th>
							<th>Received</th>
							<th>Outstanding</th>
						</tr>
					</thead>
					<tbody>
						{partners.map((partner, index) => (
							<tr key={index}>
								<td>
									<div style={{ fontWeight: "600" }}>{partner.partnerName}</div>
									<div style={{ fontSize: "11px", color: "var(--text-muted)" }}>
										{partner.revenuePercentage}% of total
									</div>
								</td>
								<td>
									<div style={{ fontWeight: "600", color: "var(--success-color)" }}>
										{formatCurrency(partner.ourRevenueUSD)}
									</div>
								</td>
								<td>
									<div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
										{getVarianceIcon(partner.varianceAcceptable)}
										<span style={{ fontWeight: "600" }}>
											{formatCurrency(partner.partnerReportedUSD)}
										</span>
									</div>
									{partner.varianceUSD !== 0 && (
										<div style={{
											fontSize: "11px",
											color: partner.varianceUSD < 0 ? "var(--danger-color)" : "var(--success-color)"
										}}>
											{partner.varianceUSD > 0 ? '+' : ''}{formatCurrency(partner.varianceUSD)}
										</div>
									)}
								</td>
								<td>
									<div style={{ fontWeight: "600" }}>
										{formatCurrency(partner.userPayoutUSD)}
									</div>
									<div style={{ fontSize: "11px", color: "var(--text-muted)" }}>
										{partner.payoutRatio}% ratio
									</div>
								</td>
								<td>
									<div style={{ fontWeight: "600", color: "var(--primary-color)" }}>
										{formatCurrency(partner.marginUSD)}
									</div>
									<div style={{ fontSize: "11px", color: "var(--text-muted)" }}>
										{partner.marginPercentage}%
									</div>
								</td>
								<td>
									<div style={{ fontWeight: "600" }}>
										{formatCurrency(partner.receivedUSD)}
									</div>
									<div style={{ fontSize: "11px", color: "var(--text-muted)" }}>
										{partner.receivedPercentage}%
									</div>
								</td>
								<td>
									<div style={{ fontWeight: "600", color: getStatusColor(partner.overdueDays) }}>
										{formatCurrency(partner.outstandingUSD)}
									</div>
									{partner.dueDate && (
										<div style={{
											fontSize: "11px",
											color: partner.overdueDays > 0 ? "var(--danger-color)" : "var(--text-muted)"
										}}>
											{partner.overdueDays > 0
												? `${partner.overdueDays}d overdue`
												: new Date(partner.dueDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
											}
										</div>
									)}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default TopPartnersTable;